export default __webpack_public_path__ + "static/media/09_SchererGruppe-DTM-Documentary-EschweilerPhotography_M1A2860.512132aa.jpg";